export enum PAGE_TYPE {
  CONFIGURE,
  STOCK,
}

export enum DEFAULT_TAX {
  ZERO = 0,
  NON_ZERO = 2400,
}
